export const digitalCoreProjectManagementDataSources = [
  {
    title: 'Project Tracking – Azure DevOps (ADO)',
    content:
      'Get quick answers on SAP CoE project and requirement tracking through Akira – Hitachi Energy Gen AI platform. The goal is to help employees find the status, ownership, and details of Epics, Cross Streams, User Stories, and Tasks by querying Akira instead of manually searching Azure DevOps.',
    sourceSystem: null,
    prompts: [
      'Show me all related items for ADO Epic 77269',
      'Show me all related items for ADO Epic PRJ0038941',
      'Show me all child tasks under User Story: Child User story - Outbound e-invoicing',
    ],
    datasourcelink:''  
  },
  {
    title: 'Testing & Defects – Panaya',
    content:
      'Get quick answers on SAP CoE test execution and defect status through Akira – Hitachi Energy Gen AI platform. The goal is to help employees find test case results, defect details, and traceability information by querying Akira instead of manually searching Panaya.',
    sourceSystem: null,
    prompts: [
      'How many tests do we have for project PRJ0063042 New GPG/PG code GI Valves and have they been executed?',
      'For POC - Turkiye Currency Change Project - project cancel please summarize the test statuses? How many are in progress/done/defects/completed.',
      'What proof should be provided as test results and where to attach it?',
    ],
    datasourcelink:''  
  },
  {
    title: 'Project Pipeline & Governance List – SharePoint (Structured)',
    content:
      'Get quick answers on SAP CoE project pipeline status through Akira – Hitachi Energy Gen AI platform. The goal is to help employees find idea status, gate decisions, ownership, and key dates tracked in the SharePoint project list by querying Akira instead of manually searching SharePoint.',
    sourceSystem: null,
    prompts: [
      'Show me a list of projects with Gate Status Gate#4- Passed',
      'Show me projects with PPRB Decision in preparation.',
      'What is the project count where R2R is the Leading Stream.',
    ],
    datasourcelink:''  
  },
  {
    title: 'Project Documents & Reports – SharePoint (Unstructured)',
    content:
      'Get quick answers on SAP CoE project documentation through Akira – Hitachi Energy Gen AI platform. The goal is to help employees find status reports, gate deliverables, templates, and governance documents stored in SharePoint folders by querying Akira instead of manually searching through files.',
    sourceSystem: null,
    prompts: [
      'Who is part of the team for project: PRJ0038644 Poland SAF-T',
      'Show me a summary of the latest status report',
      'Who is part of the SAP CoE Support Team?',
    ],
    datasourcelink:''  
  }
]
